import { getBlockCalendarTitle } from '../selectors/getStoreProperties';
/**
 * Utility function to get oof event subject
 * @returns oof event subject from store
 */
export default function getOofEventSubject() {
    return getBlockCalendarTitle();
}
//# sourceMappingURL=getOofEventSubject.js.map